import memoize from 'memoize-one';
import { getCurrentOrganizationId } from './organizationSelectors';
import { getFilterMembersCallback } from '../helpers/Util';

export const getIsLoadingMembers = (
    state,
    selectedOrganizationId = getCurrentOrganizationId(state),
) =>
    !!state.currentOrganizations.loadingMembers &&
    !!state.currentOrganizations.loadingMembers[selectedOrganizationId];

/* Memoize function for organization members map */
const mapOrganizationMembers = memoize((users, members) =>
    members.map(membership => ({
        ...users[membership.userId],
        isAdmin: membership.isAdmin,
        permissionLevel: membership.permissionLevel,
    })),
);

const filterOrganizationMembers = memoize((members, filterTerm) => {
    const filterCallback = getFilterMembersCallback(filterTerm);
    return members.filter(filterCallback);
});

export const getOrganizationMembersSearchTerm = state => {
    return state.organizationMembersFilter.searchTerm;
};

export const getMembers = (
    state,
    selectedOrganizationId = getCurrentOrganizationId(state),
) => {
    const members = state.usersByOrg[selectedOrganizationId];
    if (!members) {
        return undefined;
    }
    const users = state.db.users;
    const filterTerm = getOrganizationMembersSearchTerm(state);
    return filterOrganizationMembers(
        mapOrganizationMembers(users, members),
        filterTerm,
    ).sort((a, b) =>
        `${a.firstName} ${a.lastName}`.localeCompare(
            `${b.firstName} ${b.lastName}`,
        ),
    );
};



// WEBPACK FOOTER //
// ./src/selectors/organizationMembersSelectors.js